module.exports = __webpack_public_path__ + "media/images/story/typo/declarationResort-1fd0b1c868a1aae9efc27adcb31fd941.svg";